import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Form from '../../../../form/field';
import fieldLogic from '../logic/fieldsLogic';
import useInputRef from './useInputRef';
import FormHelperText from '@material-ui/core/FormHelperText';

var FormFieldRating = function FormFieldRating(props) {
  var active = props.active,
      value = props.value,
      fieldId = props.fieldId,
      dispatch = props.dispatch,
      required = props.required,
      error = props.error,
      readonly = props.readonly,
      description = props.description,
      scale = props.scale,
      name = props.name,
      icon = props.icon;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var onChange = function onChange(event) {
    if (!event) return;
    fieldLogic.onChange(fieldId, parseInt(event.target.value), dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var hasError = !!error;
  return React.createElement(React.Fragment, null, React.createElement(Form.Input.Rating, {
    inputRef: inputRef,
    value: value || null,
    onChange: onChange,
    readOnly: readonly,
    disabled: readonly,
    max: parseInt(scale) || 5,
    name: name,
    required: required,
    iconType: icon,
    onFocus: onFocus,
    onBlur: onBlur
  }), (hasError || description) && React.createElement(FormHelperText, {
    error: hasError,
    margin: "dense"
  }, error || description || ' '));
};

export default React.memo(FormFieldRating);